// extracted by mini-css-extract-plugin
module.exports = {"starsContainer":"Stars_starsContainer__2LzrF"};